import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import adminApiClient, {
  ACHPaymentRequestModel,
  AddAccountNumberRequestModel,
} from 'api/adminApiClient';

interface ACHPaymentsState {}

const initialState: ACHPaymentsState = {};

const getACHUnprocessedPayments = createAsyncThunk(
  'achPayments/getACHUnprocessedPayments',
  async (pageNumber: number) => {
    return adminApiClient.getACHPayments(pageNumber);
  },
);

const getAccountNumbers = createAsyncThunk(
  'achPayments/getAccountNumbers',
  async () => {
    return adminApiClient.getAccountNumbers();
  },
);

const addAccountNumberToPayment = createAsyncThunk(
  'achPayments/addAccountNumberToPayment',
  async (accountNumberData: AddAccountNumberRequestModel) => {
    return adminApiClient.addAccountNumberToPayment(accountNumberData);
  },
);

const uploadACHPayments = createAsyncThunk(
  'achPayments/uploadACHPayments',
  async (achPayments: ACHPaymentRequestModel) => {
    return adminApiClient.createACHPayment(achPayments);
  },
);

const getACHPaymentFile = createAsyncThunk(
  'achPayments/getACHPaymentFile',
  async (id: string) => {
    return adminApiClient.getACHPaymentFile(id);
  },
);

const achPaymentsSlice = createSlice({
  name: 'achPayments',
  initialState,
  reducers: {},
});

const { reducer } = achPaymentsSlice;

export {
  getAccountNumbers,
  uploadACHPayments,
  getACHPaymentFile,
  addAccountNumberToPayment,
  getACHUnprocessedPayments,
};
export default reducer;
